const PageNotFound = () => {
    return (
        <>
        <h1>Page Not Found (404)</h1>
        <p>
        Oops, it looks like the page you're trying to reach doesn't exist. It may have been moved, deleted, or never existed in the first place.
        </p>
        <p>
        Here are a few things you can try:
        </p>
        <p>
        Double-check the URL for typos.
        Go back to our homepage and navigate from there.
        Use our search function to find what you're looking for.
        If you followed a link from another page, please let us know so we can fix it.
        If you believe this is an issue on our end, please contact our support team for assistance
        </p>
        </>
    )
}

export default PageNotFound;